import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { EmptyState } from '../../../../components/ui/common';
import { ClientMessages } from '../../../../features/B2b/ClientMessages';
import { clientMessagesSearchSchema, type ClientMessagesSearch } from '../../../../features/B2b/search';
import { useCan } from '../../../../lib/session';

/** Client page "הודעות" tab — lane B2b-web. The Outbox log filtered by the route's clientId. */
export const Route = createFileRoute('/_app/client/$clientId/messages')({
  validateSearch: (s: Record<string, unknown>): ClientMessagesSearch => clientMessagesSearchSchema.parse(s),
  component: ClientMessagesTab,
});

function ClientMessagesTab() {
  const can = useCan();
  const { clientId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const setSearch = useCallback(
    (patch: Partial<ClientMessagesSearch>, replace = false) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace }),
    [navigate],
  );
  if (!can('logs.messages.view')) {
    return <EmptyState icon="shield" title="אין לך הרשאה לצפות בהודעות" text="מנהל המערכת יכול לתת לך הרשאת צפייה בלוג ההודעות." />;
  }
  return <ClientMessages clientId={clientId} search={search} setSearch={setSearch} />;
}
